import React from 'react';

import Script from 'dangerous-html/react';

const StatsSection: React.FC = () => (
    <section className="stats-wrapper">
          <div className="stats-container">
            <div className="stats-header">
              <h2 className="section-title">Impact by Numbers</h2>
              <p className="section-subtitle">
                Measurable outcomes from extensive technical leadership and delivery.
              </p>
            </div>
            <div className="stats-carousel-container">
              <button
                id="statsPrev"
                aria-label="Previous stat"
                className="stats-carousel-button stats-carousel-button-prev"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m15 18l-6-6l6-6"
                  ></path>
                </svg>
              </button>
              <div className="stats-carousel-track">
                <div className="stats-carousel-item">
                  <div className="stats-carousel-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M8 2v4m8-4v4"></path>
                        <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                        <path d="M3 10h18"></path>
                      </g>
                    </svg>
                  </div>
                  <div className="stats-carousel-value">
                    <span>18+</span>
                  </div>
                  <div className="stats-carousel-label">
                    <span>Years of Experience</span>
                  </div>
                  <p className="stats-carousel-description">
                    {' '}
                    Comprehensive full-stack and cloud application development
                    across diverse industries
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </p>
                </div>
                <div className="stats-carousel-item">
                  <div className="stats-carousel-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z"></path>
                        <path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12"></path>
                        <path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17"></path>
                      </g>
                    </svg>
                  </div>
                  <div className="stats-carousel-value">
                    <span>6+</span>
                  </div>
                  <div className="stats-carousel-label">
                    <span>Years in Architecture</span>
                  </div>
                  <p className="stats-carousel-description">
                    {' '}
                    Leading architectural roles designing resilient cloud-native
                    solutions
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </p>
                </div>
                <div className="stats-carousel-item">
                  <div className="stats-carousel-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"
                      ></path>
                    </svg>
                  </div>
                  <div className="stats-carousel-value">
                    <span>99.98%</span>
                  </div>
                  <div className="stats-carousel-label">
                    <span>Uptime Achieved</span>
                  </div>
                  <p className="stats-carousel-description">
                    {' '}
                    High availability across mission-critical retail microservices
                    platform
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </p>
                </div>
                <div className="stats-carousel-item">
                  <div className="stats-carousel-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.4 22.4 0 0 1-4 2"></path>
                        <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0m1 7v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"></path>
                      </g>
                    </svg>
                  </div>
                  <div className="stats-carousel-value">
                    <span>25%</span>
                  </div>
                  <div className="stats-carousel-label">
                    <span>Efficiency Improvement</span>
                  </div>
                  <p className="stats-carousel-description">
                    {' '}
                    Enhanced team delivery efficiency through mentorship and
                    process optimization
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </p>
                </div>
                <div className="stats-carousel-item">
                  <div className="stats-carousel-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M12 18V5m3 8a4.17 4.17 0 0 1-3-4a4.17 4.17 0 0 1-3 4m8.598-6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5"></path>
                        <path d="M17.997 5.125a4 4 0 0 1 2.526 5.77"></path>
                        <path d="M18 18a4 4 0 0 0 2-7.464"></path>
                        <path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517"></path>
                        <path d="M6 18a4 4 0 0 1-2-7.464"></path>
                        <path d="M6.003 5.125a4 4 0 0 0-2.526 5.77"></path>
                      </g>
                    </svg>
                  </div>
                  <div className="stats-carousel-value">
                    <span>2+</span>
                  </div>
                  <div className="stats-carousel-label">
                    <span>Years in Generative AI</span>
                  </div>
                  <p className="stats-carousel-description">
                    {' '}
                    Specialized focus on AI-driven analytics and AWS Bedrock
                    implementations
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </p>
                </div>
                <div className="stats-carousel-item">
                  <div className="stats-carousel-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9"
                      ></path>
                    </svg>
                  </div>
                  <div className="stats-carousel-value">
                    <span>50+</span>
                  </div>
                  <div className="stats-carousel-label">
                    <span>Cloud Projects Delivered</span>
                  </div>
                  <p className="stats-carousel-description">
                    {' '}
                    Successful cloud-native architectures across AWS,
                    microservices, and serverless
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </p>
                </div>
              </div>
              <button
                id="statsNext"
                aria-label="Next stat"
                className="stats-carousel-button stats-carousel-button-next"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m9 18l6-6l-6-6"
                  ></path>
                </svg>
              </button>
            </div>
            <div id="statsDots" className="stats-carousel-dots"></div>
          </div>
        </section>
);

export default StatsSection;
